import React from 'react';
import '../styles/PropertyObstructions.css';

function PropertyObstructions(props) {
    const property = props.property;
     
     const obstructions = [
        {
            label: "🛣️ Highway between properties",
            value: property.compDetails.highway
        },
        {
            label: "💦 Body of water between properties",
            value: property.compDetails.water
        },
        {
            label: "🚂 Railroad between properties",
            value: property.compDetails.railroad
        }
    ];

    return (
        <div className="property-obstructions-container">
            {
                obstructions.findIndex(e => e.value === true) === -1 ?
                <span className="body-regular colour-primary">
                    No obstructions detected
                </span>
                :
                obstructions.map((item, index) =>
                    item.value === true &&
                    <span 
                        className="body-regular colour-primary" 
                        key={index}
                    >
                        {item.label}
                    </span>
                )
            }
        </div>
    )
};

export default PropertyObstructions;